import { render, staticRenderFns } from "./d-genres-signup-form.vue?vue&type=template&id=71a2fb96&"
import script from "./d-genres-signup-form.vue?vue&type=script&lang=js&"
export * from "./d-genres-signup-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports